import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import systemRoutes from './modules/system'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/article',
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'ArticleList',
        component: () => import('@/views/article/list'),
        meta: { title: '文章列表' }
      },
      {
        path: 'category',
        name: 'ArticleCategory',
        component: () => import('@/views/category/index'),
        meta: { title: '分类管理' }
      }
    ]
  },
  {
    path: '/app-config',
    component: Layout,
    children: [
      {
        path: 'banner',
        name: 'Banner',
        component: () => import('@/views/app_config/banner'),
        meta: { title: '轮播图管理' }
      },
      {
        path: 'grid-menu',
        name: 'GridMenu',
        component: () => import('@/views/app_config/grid_menu'),
        meta: { title: '九宫格菜单' }
      },
      {
        path: 'index',
        name: 'AppConfig',
        component: () => import('@/views/app_config/index'),
        meta: { title: '其他配置' }
      }
    ]
  },
  {
    path: '/memory',
    component: Layout,
    children: [
      {
        path: 'category',
        name: 'MemoryCategory',
        component: () => import('@/views/memory/category'),
        meta: { title: '分类管理' }
      },
      {
        path: 'article',
        name: 'MemoryArticle',
        component: () => import('@/views/memory/article'),
        meta: { title: '文章管理' }
      }
    ]
  },
  {
    path: '/question',
    component: Layout,
    children: [
      {
        path: 'category',
        name: 'BankCategory',
        component: () => import('@/views/question/category'),
        meta: { title: '题库分类' }
      },
      {
        path: 'bank',
        name: 'QuestionBank',
        component: () => import('@/views/question/index'),
        meta: { title: '题库管理' }
      },
      {
        path: 'bank/:id',
        name: 'QuestionList',
        component: () => import('@/views/question/list'),
        meta: { title: '题目管理', hidden: true }
      },
      {
        path: 'correction',
        name: 'QuestionCorrection',
        component: () => import('@/views/question/correction'),
        meta: { title: '纠错记录' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    children: [
      {
        path: 'agreement',
        name: 'Agreement',
        component: () => import('@/views/system/agreement'),
        meta: { title: '协议管理' }
      },
      {
        path: 'version',
        name: 'Version',
        component: () => import('@/views/system/version'),
        meta: { title: '版本管理' }
      }
    ]
  },
  {
    path: '/shop',
    component: Layout,
    meta: { title: '商城管理', icon: 'el-icon-shopping-cart-2' },
    children: [
      {
        path: 'product',
        name: 'ShopProduct',
        component: () => import('@/views/shop_product/index'),
        meta: { title: '商品管理' }
      },
      {
        path: 'top-section',
        name: 'MallTopSection',
        component: () => import('@/views/mall_config/top_section'),
        meta: { title: '顶部资料专区' }
      },
      {
        path: 'service-guarantee',
        name: 'MallServiceGuarantee',
        component: () => import('@/views/mall_config/service_guarantee'),
        meta: { title: '服务保障配置' }
      }
    ]
  },
  systemRoutes
]

const createRouter = () => new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router 